/* nexusProvider.ts */
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import nexusClient from './nexusClient';

Vue.use(VueApollo);

const nexusProvider = new VueApollo({
  defaultClient: nexusClient
});

export default nexusProvider;
